import { HttpHeaders } from '@angular/common/http';

export function createHttpOptions(
  acceptType: string = 'text/plain',
  contentType: string = 'application/json',
  accessToken?: string,
) {
  const headersConfig: { [key: string]: string } = {
    'Content-Type': contentType,
    Accept: acceptType,
    ...(!!accessToken && { Authorization: `Bearer ${accessToken}` }),
  };

  return {
    headers: new HttpHeaders(headersConfig),
  };
}
